import { latestLeaks } from '@/mocks/home';

export default function LatestSection() {
  return (
    <section id="latest" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="reveal flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.3em] text-primary-700">
              <i className="ri-chat-quote-line text-[14px]" />
              LATEST
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新爆料
            </h2>
          </div>
          <a
            href="#latest"
            className="inline-flex w-fit items-center gap-1.5 font-label text-[13px] text-foreground-600 transition-colors hover:text-primary-600"
          >
            查看全部线索
            <i className="ri-arrow-right-line text-[15px]" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-x-10 gap-y-2 lg:grid-cols-2">
          {latestLeaks.map((item, index) => (
            <article
              key={item.title}
              className="reveal group cursor-pointer border-b border-background-200 py-6"
            >
              <div className="flex items-start gap-4">
                <span className="mt-0.5 font-heading text-[13px] font-semibold text-foreground-300">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-[16px] font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mt-2 font-body text-[13.5px] leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex flex-wrap items-center gap-3">
                    <span className="rounded-md bg-primary-50 px-2 py-0.5 font-label text-[11px] text-primary-700">
                      {item.category}
                    </span>
                    <span className="font-label text-[11.5px] text-foreground-500">
                      <i className="ri-time-line mr-1 text-[12px]" />
                      {item.time}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}